import './Loading.css'

export function Loading() {
  return (
    <div className='loading'>
      <i className='bx bx-loader-alt'></i>
      <p>loading...</p>
    </div>
  )
}
